import { cn } from '../../lib/cn';

// Kontener sekcji. Ujednolica ~15 miejsc, w których powtarzał się wariant
// "bg-white p-6 rounded-lg shadow-md border border-gray-200" — z paddingiem
// raz 4, raz 6, raz 8, i cieniem raz md, raz sm.

export function Card({ className, children, padded = true, ...props }) {
  return (
    <section
      className={cn(
        'rounded-lg border border-line bg-surface shadow-card',
        padded && 'p-4',
        className
      )}
      {...props}
    >
      {children}
    </section>
  );
}

export function CardHeader({ title, description, icon: Icon, actions, className }) {
  return (
    <div className={cn('flex flex-wrap items-start justify-between gap-3', className)}>
      <div className="flex min-w-0 items-start gap-2.5">
        {Icon && (
          <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-elevated text-muted">
            <Icon size={15} />
          </span>
        )}
        <div className="min-w-0">
          <h2 className="text-sm font-semibold text-content">{title}</h2>
          {description && <p className="mt-0.5 text-xs text-muted">{description}</p>}
        </div>
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}

export default Card;
